import { disconnectPresenceSessions } from "../gateways/disconnectPresenceSessions";
import { runVoiceSessionCleanup } from "../gateways/voiceSessionCleanup";
import { clearModalDockStorage } from "./modalDockStorage";

export const performSignOut = async (
  companyId?: string | number | null,
): Promise<void> => {
  await disconnectPresenceSessions(companyId);
  await runVoiceSessionCleanup();

  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("refresh_token");
  sessionStorage.removeItem("refresh_token");
  localStorage.removeItem("activeCompanyId");
  sessionStorage.removeItem("activeCompanyId");
  clearModalDockStorage();
};
